import script from "./LingoModalComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LingoModalComponent.vue?vue&type=script&setup=true&lang=ts"

import "./LingoModalComponent.vue?vue&type=style&index=0&id=07f2227d&scoped=true&lang=css"

import exportComponent from "/builds/lightswitch/reflective/reflective-learning-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07f2227d"]])

export default __exports__